module.exports = __webpack_public_path__ + "595a0889.svg";